<template>
  <ContentLayout>
    <template #header>
      <h4>O Alcafozense</h4>
      <button v-if="selected" @click="selected = null" class="btn space-left">Voltar a Listagem</button>
    </template>

    <div v-if="!token" class="center">
      <div v-show="problem" class="error">{{ msg || 'SENHA INVÁLIDA' }}</div>
      <input type="text" placeholder="Senha de Acesso" v-model="password" /><br/>
      <button class="btn" @click="login()">Entrar</button>
    </div>
    <div v-else>
      <div v-if="!selected">
        <ul>
          <li v-for="(item, key) in list" :key="key" @click="selectNewspaper(item)">{{ String(item).replace('.pdf', '') }}</li>
        </ul>
      </div>
      <div v-else>
        <pdf-viewer :source="'./pdf/alcafozense/'+ selected" />
      </div>
    </div>
  </ContentLayout>
</template>

<script>
import ContentLayout from '../components/ContentLayout';

export default {
  components: {
    ContentLayout
  },
  data: () => ({
    token: null,
    password: '',
    selected: null,
    problem: false,
    msg: null,
    list: []
  }),
  methods: {
    async login() {
      this.problem = false;
      this.msg = null
      const result = await this.$api.alcafozenseLogin(this.password);
      if (!result.data || result.error) {
        const lastPayedYear = String(result.error.response.data).split(' ')[1]
        if (result.error.response.status === 402) this.msg = 'Quota(s) em atrazo | Ultima Quota Paga = '+ lastPayedYear
        
        this.problem = true;
        return false;
      }

      localStorage.setItem('reader-token', result.data);
      this.token = result.data;
      this.getNewspapers();
      return true;
    },
    async validate() {
      const token = localStorage.getItem('reader-token');
      if (!token) {
        return false;
      }

      const response = await this.$api.alcafozenseValidate(token);
      if (!response.data || response.error) {
        localStorage.removeItem('reader-token');
        this.token = null;
        return false;
      }

      this.token = token;
      return true;
    },
    async selectNewspaper(item) {
      const valid = await this.validate();
      if (valid) {
        this.selected = item;
        return;
      }

      this.selected = null;
      return;
    },
    async getNewspapers() {
      const list = await this.$api.alcafozenseList(this.token);
      this.list = list.data;
    }
  },
  async mounted() {
    const valid = await this.validate();
    if (valid) await this.getNewspapers();
  }
};
</script>

<style lang="scss" scoped>
.space-left {
  margin-left: auto;
}

.center {
  text-align: center;
}

.error {
  background: #f56565;
  margin: 5px 0;
  padding: 15px;
  border-radius: 4px;
  font-weight: bold;
  color: #fff;
}

input {
  margin-bottom: 16px;
  border: 1px solid grey;
  border-radius: 4px;
  padding: 10px;
  font-weight: bold;
  font-size: 1.4rem;
  
  &:hover {
    border-color: grey;
  }
}

ul {
  -moz-column-count: 7;
  -webkit-column-count: 7;
  column-count: 7;
}

li {
  border: 1px solid var(--color-grey);
  padding: 10px;
  margin-bottom: 4px;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid-column;
  list-style: none;
  cursor: pointer;
}

li:nth-child(2n+1) {
  background: #f1f1f1;
}


@media (max-width: 900px) {
  ul {
    -moz-column-count: 4;
    -webkit-column-count: 4;
    column-count: 4;
  }
}
</style>
